<template>
  <v-menu
    ref="menu"
    v-model="showMenu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="dateFormatted"
        :label="label"
        hint="DD.MM.YYYY (z.B. 15.03.2023)"
        persistent-hint
        prepend-icon="mdi-calendar"
        clearable
        v-bind="attrs"
        v-on="on"
        @blur="onDateFormattedChange(dateFormatted)"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="date"
      @change="onDateChange"
      no-title
      scrollable
    >
    </v-date-picker>
  </v-menu>
</template>

<script>
import moment from "moment/moment"

export default {
  name: 'TextFieldDatePicker',
  props: {
    label: {
      type: String,
      default: 'Select Date'
    },
    useFallBackDate: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      date: null,
      dateFormatted: null,
      showMenu: false
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (newValue) {
        if (newValue) {
          if (newValue.includes('-')) {
            this.date = newValue
            this.dateFormatted = this.formatIsoDate(newValue)
          } else {
            this.dateFormatted = newValue
            this.date = this.parseDate(newValue)
          }
        }
      }
    }
  },
  mounted () {
    const startOfLastYear = moment()
      .subtract(1, 'year')
      .startOf('year')

    this.date = this.useFallBackDate ? startOfLastYear.format('YYYY-MM-DD') : null
    this.dateFormatted = this.formatIsoDate(this.date)
    this.$emit('input', this.date)
  },
  methods: {
    parseDate (date) {
      if (!date) return null
      const [day, month, year] = date.split('.').map(Number)
      return `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`
    },
    formatIsoDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-').map(Number)
      return `${day.toString().padStart(2, '0')}.${month.toString().padStart(2, '0')}.${year}`
    },
    onDateChange (newDate) {
      this.dateFormatted = this.formatIsoDate(newDate)
      this.$emit('input', this.dateFormatted)
      this.showMenu = false
    },
    onDateFormattedChange (newDate) {
      this.date = this.parseDate(newDate)
      this.$emit('input', newDate)
    }
  },
}
</script>
